/**
 * 系统工具
 * @author zhudc
 * @date 2022-08-16
 */

/**
 * 检查是否为微信
 */
export function checkIsWechat() {
  return /MicroMessenger/gi.test(window.navigator.userAgent);
}

/**
 * 判断是否为Android
 */
export function checkIsAndroid() {
  return /android/i.test(window.navigator.userAgent);
}

/**
 * 判断是否为iPad
 */
export function checkIsIPad() {
  const isPadPro = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  const isPad = /ipad/i.test(window.navigator.userAgent) || isPadPro;
  return isPad;
}

/**
 * 判断是否为移动端
 */
export function checkIsMobile() {
  if (window.navigator.userAgent.match(/mobile/i)) {
    return true;
  }

  const isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (isIOS) {
    return true;
  }

  if (window.navigator.userAgent.match(/android/i)) {
    return true;
  }

  return false;
}

/**
 * 检查是否为微博
 */
export function checkIsWeibo() {
  return /weibo/i.test(window.navigator.userAgent);
}

/**
 * 获取iOS版本
 * @returns Number
 */
export function getIosVersion() {
  const ua: any = window.navigator.userAgent;
  if (ua.match(/os\s+(\d+)/i)) {
    return ua.match(/os\s+(\d+)/i)[1] - 0;
  }
  return 0;
}
